module.exports = __webpack_public_path__ + "static/media/puffy.0a33db39.png";